import { Box, Button } from "@mui/material";
import { Dashboard } from "../../types";

interface IToolsNavigationProps {
  dashboards: Dashboard[];
  handleDashboardChange: (value: Dashboard) => void;
  currentDashboard: Dashboard | null;
}
const ToolsNavigation = ({ dashboards, handleDashboardChange, currentDashboard }: IToolsNavigationProps) => {
  return (
    <Box
      sx={{
        width: "100%",
        display: "flex",
        gap: "8px",
        paddingY: "12px",
        paddingX: "16px"
      }}
    >
      {dashboards?.map((dashboard) => (
        <Button
          sx={{
            gap: 12,
            textTransform: "none",
            border: "1px solid",
            backgroundColor: currentDashboard?.name === dashboard.name ? "primary.main" : "",
            borderColor: "#fff",
            borderRadius: "0.75rem",
            color: "#fff"
          }}
          variant={currentDashboard?.name === dashboard.name ? "contained" : "outlined"}
          onClick={() => {
            handleDashboardChange(dashboard);
          }}
          aria-label='Back to grid'
          disableElevation
        >
          {dashboard.name}
        </Button>
      ))}
    </Box>
  );
};

export default ToolsNavigation;
